module.exports = __webpack_public_path__ + "assets/35ba9ca6c3b44a5d5e3f02777d2344b9.png";